/**
 * 火花接口请求帮助类
 *@author caijing
 *@date 2022/3/2 13:24
 */
import axios from 'axios';
import * as querystring from 'querystring';
import { BaseServiceImpl } from '@/service/BaseServiceImpl';
import { HuohuaError } from '@/service/exception/HuohuaError';
import { LocalStorageManager } from '@/db/LocalStorageManager';
import { LocalStorageKey } from '@/constant/LocalStorageKey';

export class HuohuaRequestHelper {
  private static huohuaAxios: HuohuaRequestHelper;

  constructor() {
    this.initInterceptors();
  }

  public static getInstance(): HuohuaRequestHelper {
    if (HuohuaRequestHelper.huohuaAxios == null) {
      HuohuaRequestHelper.huohuaAxios = new HuohuaRequestHelper();
    }

    return HuohuaRequestHelper.huohuaAxios;
  }

  /**
   * 初始化拦截器
   */
  initInterceptors() {
    axios.interceptors.response.use(
      (response) => {
        return Promise.resolve(response);
      },
      (error) => {
        const exception = new HuohuaError(error);
        return Promise.reject(exception);
      }
    );
  }

  /**
   * 获取axios request
   */
  getHuohuaRequest(option: any) {
    const token = LocalStorageManager.getItem(LocalStorageKey.token);
    if (token) {
      option.headers.token = token;
    }
    if (option.method === 'POST') {
      option.transformRequest = [
        function (data: any) {
          const contentType = option.headers['Content-Type'];
          if (contentType && contentType === BaseServiceImpl.jsonContentType) {
            return data;
          } else {
            return querystring.stringify(data);
          }
        }
      ];
    } else if (option.method === 'GET') {
      option.paramsSerializer = function (params: any) {
        return querystring.stringify(params);
      };
    } else if (option.method === 'DELETE') {
      option.paramsSerializer = function (params: any) {
        return querystring.stringify(params);
      };
    } else if (option.method === 'PUT') {
      option.paramsSerializer = function (params: any) {
        return querystring.stringify(params);
      };
    }
    return axios.request(option);
  }
}
